import React, { useEffect, useMemo, useState } from 'react';
import NoIndex from '../components/NoIndex';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { getFirestore, doc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';
import ExcelJS from 'exceljs';
import JSZip from 'jszip';
import Styles from './styles.module.css';

type GuidanceEntry = {
  name: string;
  companyId: string;
  recruitId: string;
  status: string;
  createdAt?: any;
};

type StudentRow = {
  uid: string;
  department: string;
  grade: string;
  class: string;
  number: string;
  name: string;
  choices: string[];
  answered: boolean;
  reported: boolean;
};

const statusPriority = (row: StudentRow) => {
  if (row.reported) return 2;
  if (row.answered) return 0;
  return 1;
};

const STATUS_LABEL: Record<number, string> = { 0: '回答済み', 1: '未回答', 2: '内定承諾' };

type SalonCount = {
  name: string;
  counts: number[];
  total: number;
  total5: number;
};

const CHOICE_LABELS = ['第1志望群', '第1志望群', '第1志望群', '第2志望群', '第2志望群', '第2志望群'];

const ORDERED_SALON_IDS_BY_SCHOOL: Record<string, string[]> = {
  '群馬県美容専門学校': [
    'kpfxWkjLTraEERcbWXFhgkdEY2Z2_2027',
    'GVdFZYujfxUgC2hfxJRz4aW13Ps2_2027',
    '2s9vPsoMykhapAjp4U4AXHj2ty82_2027',
    'vBFyfGkNbbZVs6eftF3t1gImZWr2_2027',
    'gZseoqmc94UehARQwR0miF7LNni2_2027',
    'IjRbZiAinJg4aXrVb77zleLQsXk2_2027',
    'sHBNoVsORIT2hmmjHrZSoNFVmpr2_2027',
    'dZYX7r4kcGTiZEvPjz7AF0cdCT03_2027',
    'GUcbiCyOHVeDRvkSDb7u5XSuJc03_2027',
    'N3APwpxQ4WZQqTXrFQB9yuf8vjs1_2027',
  ],
  'ハリウッドワールド美容専門学校': [
    'xs4NiZp3o6WovSDuDRGub5Vhqun1_2027',
    'cEYfCZzZQfSCsSkpxkiO90H2xzN2_2027',
    'U83jaSl6ceUIm771ICI0o665IBi1_2027',
    '9ylF1Z0xDcZJnyk1eMoQzbdpkSj1_2027',
    'urzfo224HOgZd3zuv4ENRwqQoiv1_2027',
    '6f1jjTOvg3RtLhhQ6liCeSl3Lp52_2027',
    'SssZ4r18y6cPK60BNbi6zv8Ds5a2_2027',
    'QKywWL66XfVhjsNfSDjDvbELmBg2_2027',
    'r62PLghsCGVuyQhf6sSCsms7PO52_2027',
    'C4l0FB6wvoUlQZG7vTtGuqplBO12_2027',
    '9SHW6fNT7gbJHtLt7ZyuVGcCJrw1_2027',
    '0pcrLcDeGgfe11590yhrR79qh7Q2_2027',
    'UVjAqu6eKqNXYH3jhiAn0mHULQ22_2027',
    'ABok4lFQ5rXkSDv8RkoZmYCqcs12_2027',
    '6pjPXcYWcLersJYNjmJIZswhL2U2_2027',
    'aTZvVtxwgoNY1L4I7f4LTLBQ3B12_2027',
    'zriblheI1USHQd7p9jEJe9K6nF72_2027',
    'uzdLkVL8FgZ3eOxoFrGpT1a4xZO2_2027',
    'btxwyle86GUb8LxpwWfu8C4AIIt1_2027',
    'nv4ITgtRc6Mvu8Ko7I9pRA21xju2_2027',
    '7EQltPpdfIOM4FXnIPwPoddW1jf1_2027',
    'KqQ8Huk6MNPyUtamCpX4JZkl9hE3_2027',
    'KHqIuAeuBKeKv985I4n1T8MdNF12_2027',
    'qDUr1zwsblg66Bvep0CLfJQGK7Q2_2027',
    'cfe8381a-2bf2-4c94-8e01-7f6759246bbc_2027',
    '29QMTJWlGhXJyxmOLodu9l4ocFB3_2027',
    'b60PeUsc1jYB4BSDJ9gZluU7Bvs2_2027',
    'IkxJaaYBptQuLE6zPlbNsuzFfl93_2027',
    'qAgjUN4xhVb3gcK8vmvXTTpaDNg1_2027',
    'C4BcqcbtIPOqpoOqtOm2GaJ0noP2_2027',
    '3ee2Kr43mHYwioiWLFVeWpAJGyo1_2027',
    'cHT7gqa3hwZZ797yiCJPa1l4nCh1_2027',
    'f490ac52-caf2-42ac-977e-65fe39f051e7_2027',
    'aZcUwtYrAdUuOAAkHCayx271RwP2_2027',
    'f49209ad-c95e-452f-9092-8bf6b9d222f0_2027',
    'JVtcDGSFXpTZ1XjhyDRBj69dKQz1_2027',
    '7106edfc-4750-43a9-8a67-8a8802910b48_2027',
    'LhuJmg0lJYhIJTI6GaegDuCn11x2_2027',
    'ZUq13XKBfWZsk1vNZereEQm7WId2_2027',
    'xrJ0MmWVsOfZ1pe9sAYeMbLEOAj1_2027',
    'ced09e52-601b-4461-8b98-9f2cc75f37f2_2027',
    'nGSFuKymSAZqwHAZpBs9J1XNa9h2_2027',
    '3SWsGXIZQ2a33mTl1v2QxwPVIaJ3_2027',
    'dOzEp2mfhxeKq99CEKPp8XYom563_2027',
    'efo0y7mvvdN4wd0JugVp5CfjG1o1_2027',
    'b181d38a-5049-485a-b2c9-586453d859c0_2027',
    'fiT2zg4tOUVK4FEK7UB9THT6Mt52_2027',
    'R5bMuUqWbbN4OQeO3Io9VxdedO82_2027',
    'MMAr1QD3oIdb70vn0CuXyOKeeDa2_2027',
    '2jZ2jnVvEwcUbiV2E1kxYg2rDpg1_2027',
    'wytk0yPrjDbEiPcZZekqaJTA7Jg2_2027',
    'keHnbFwuKsNgQhPO0XHBS8usUhL2_2027',
  ],
};

const SanpouPage: React.FC = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getFirestore();

  const [authorized, setAuthorized] = useState(false);
  const [sanpouInfo, setSanpouInfo] = useState<any>(null);
  const [guidances, setGuidances] = useState<string[]>([]);
  const [selectedGuidance, setSelectedGuidance] = useState('');
  const [view, setView] = useState<'students' | 'salons'>('students');
  const [rows, setRows] = useState<StudentRow[]>([]);
  const [loading, setLoading] = useState(false);
  const [orderedSalonNames, setOrderedSalonNames] = useState<string[]>([]);

  const [filterDept, setFilterDept] = useState('');
  const [filterGrade, setFilterGrade] = useState('');
  const [filterClass, setFilterClass] = useState('');
  const [sortConfig, setSortConfig] = useState<{ key: 'none' | 'status' | 'class'; dir: 'asc' | 'desc' }>({ key: 'none', dir: 'asc' });

  const toggleSort = (key: 'status' | 'class') => {
    setSortConfig(prev =>
      prev.key === key
        ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' }
        : { key, dir: 'asc' }
    );
  };

  // Auth check & initial data load
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) { navigate('/sanpou/login'); return; }

      const snap = await getDoc(doc(db, 'info', 'sanpou'));
      const data = snap.data();
      const authList: string[] = data?.auth ?? [];

      if (!authList.includes(user.uid)) {
        await signOut(auth);
        navigate('/sanpou/login');
        return;
      }

      const guidanceList: string[] = data?.guidances ?? [];
      setSanpouInfo(data);
      setGuidances(guidanceList);
      if (guidanceList.length > 0) setSelectedGuidance(guidanceList[0]);
      setAuthorized(true);
    });
    return () => unsubscribe();
  }, []);

  // Fetch ordered salon names from searchIndex whenever the selected guidance (school) changes
  useEffect(() => {
    if (!selectedGuidance) return;
    const fetchSalonNames = async () => {
      const ids = ORDERED_SALON_IDS_BY_SCHOOL[selectedGuidance] ?? [];
      const names = await Promise.all(
        ids.map(async (id) => {
          const snap = await getDoc(doc(db, 'searchIndex', id));
          return (snap.data()?.name ?? '') as string;
        })
      );
      setOrderedSalonNames(names);
    };
    fetchSalonNames();
  }, [selectedGuidance]);

  // Reset filters when guidance tab changes
  useEffect(() => {
    setFilterDept('');
    setFilterGrade('');
    setFilterClass('');
  }, [selectedGuidance]);

  // Fetch students when selected guidance changes
  useEffect(() => {
    if (!selectedGuidance || !sanpouInfo) return;
    fetchData(selectedGuidance);
  }, [selectedGuidance, sanpouInfo]);

  const fetchData = async (schoolName: string) => {
    setLoading(true);
    setRows([]);
    try {
      const criteria = sanpouInfo?.[schoolName];

      const usersSnap = await getDocs(
        query(collection(db, 'users'), where('education.school', '==', schoolName))
      );

      const allUsers = usersSnap.docs
        .map(d => ({ id: d.id, ...(d.data() as any) }))
        .filter(u => !String(u.education?.name ?? '').includes('テスト'))
        .filter(u => {
          if (!criteria) return true;
          const edu = u.education ?? {};
          const deptOk = !criteria.department?.length || criteria.department.includes(edu.department);
          const gradeOk = !criteria.grade?.length || criteria.grade.includes(edu.grade);
          const classOk = !criteria.class?.length || criteria.class.includes(edu.class);
          return deptOk && gradeOk && classOk;
        });

      const studentRows: StudentRow[] = await Promise.all(
        allUsers.map(async (u) => {
          const answered = u.activity?.guidance?.request === true;
          const reported = u.activity?.guidance?.report === true;
          let choices: string[] = ['', '', '', '', '', ''];

          if (answered && !reported) {
            const gSnap = await getDocs(collection(db, 'users', u.id, 'guidance'));
            const all: GuidanceEntry[] = gSnap.docs
              .map(d => d.data() as GuidanceEntry)
              .sort((a, b) => (a.createdAt?.toMillis?.() ?? 0) - (b.createdAt?.toMillis?.() ?? 0));

            const group1 = all.filter(e => e.status === '第1志望群').slice(0, 3);
            const group2 = all.filter(e => e.status === '第2志望群').slice(0, 3);
            choices = [...group1, ...group2].map(e => e.name);
            while (choices.length < 6) choices.push('');
          }

          return {
            uid: u.id,
            department: String(u.education?.department ?? ''),
            grade: String(u.education?.grade ?? ''),
            class: String(u.education?.class ?? ''),
            number: String(u.education?.number ?? ''),
            name: u.education?.name ?? '',
            choices,
            answered,
            reported,
          };
        })
      );

      studentRows.sort((a, b) => {
        if (a.grade !== b.grade) return a.grade.localeCompare(b.grade, 'ja');
        if (a.class !== b.class) return a.class.localeCompare(b.class, 'ja');
        return Number(a.number) - Number(b.number);
      });

      setRows(studentRows);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // Filter options derived from loaded rows
  const uniqueDepts = useMemo(() =>
    [...new Set(rows.map(r => r.department).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'ja')),
    [rows]
  );

  const uniqueGrades = useMemo(() =>
    [...new Set(
      rows.filter(r => !filterDept || r.department === filterDept).map(r => r.grade).filter(Boolean)
    )].sort((a, b) => Number(a) - Number(b) || a.localeCompare(b, 'ja')),
    [rows, filterDept]
  );

  const uniqueClasses = useMemo(() =>
    [...new Set(
      rows
        .filter(r => (!filterDept || r.department === filterDept) && (!filterGrade || r.grade === filterGrade))
        .map(r => r.class)
        .filter(Boolean)
    )].sort((a, b) => a.localeCompare(b, 'ja')),
    [rows, filterDept, filterGrade]
  );

  // Apply local filter
  const filteredRows = useMemo(() =>
    rows.filter(r =>
      (!filterDept || r.department === filterDept) &&
      (!filterGrade || r.grade === filterGrade) &&
      (!filterClass || r.class === filterClass)
    ),
    [rows, filterDept, filterGrade, filterClass]
  );

  const sortedRows = useMemo(() => {
    if (sortConfig.key === 'none') return filteredRows;
    return [...filteredRows].sort((a, b) => {
      let diff = 0;
      if (sortConfig.key === 'status') diff = statusPriority(a) - statusPriority(b);
      if (sortConfig.key === 'class')  diff = a.class.localeCompare(b.class, 'ja');
      return sortConfig.dir === 'asc' ? diff : -diff;
    });
  }, [filteredRows, sortConfig]);

  const computeSalonCounts = (): SalonCount[] => {
    const map: Record<string, number[]> = {};
    for (const row of filteredRows) {
      if (row.reported) continue;
      row.choices.forEach((name, i) => {
        if (!name) return;
        if (!map[name]) map[name] = [0, 0, 0, 0, 0, 0];
        map[name][i]++;
      });
    }
    return orderedSalonNames
      .filter(name => name)
      .map(name => {
        const counts = map[name] ?? [0, 0, 0, 0, 0, 0];
        return {
          name,
          counts,
          total: counts.reduce((a, b) => a + b, 0),
          total5: counts.slice(0, 5).reduce((a, b) => a + b, 0),
        };
      });
  };

  const salonCounts = view === 'salons' ? computeSalonCounts() : [];

  const downloadAll = async () => {
    // ① テンプレート読み込み
    const res = await fetch('/sanpou-template.xlsx');
    const arrayBuffer = await res.arrayBuffer();
    const wb = new ExcelJS.Workbook();
    await wb.xlsx.load(arrayBuffer);

    // ② 指定順のsearchIndexドキュメントを取得
    const orderedSalonIds = ORDERED_SALON_IDS_BY_SCHOOL[selectedGuidance] ?? [];
    const rawList = await Promise.all(
      orderedSalonIds.map(async (id) => {
        const snap = await getDoc(doc(db, 'searchIndex', id));
        return { id, ...(snap.data() as any) };
      })
    );

    // ③ 各求人の企業名を取得（orderedSalonIds順 = 集計表A列の配置番号順）
    const salonList = await Promise.all(
      rawList.map(async (item, index) => {
        let companyName = '';
        if (item.companyId) {
          const compSnap = await getDoc(doc(db, 'companies', item.companyId));
          companyName = compSnap.data()?.name ?? '';
        }
        return {
          number: index + 1,
          salonName: item.name ?? '',
          companyName,
        };
      })
    );

    // サロン名 → { 配置番号, 会社名 } のマップ（名簿の各回ブロックに入れる値）
    const salonInfoMap: Record<string, { number: number; companyName: string }> = {};
    salonList.forEach(s => { salonInfoMap[s.salonName] = { number: s.number, companyName: s.companyName }; });

    // ④ 集計表シートに書き込む (B=企業名, C=サロン名、A列はテンプレートの既存値を使用)
    const ws集計表 = wb.getWorksheet('集計表');
    if (ws集計表) {
      salonList.forEach((s, i) => {
        const r = i + 2;
        ws集計表.getCell(`B${r}`).value = s.companyName;
        ws集計表.getCell(`C${r}`).value = s.salonName;
      });

      // テンプレートのP列見出しが「1～4合計」のままになっているが、第1志望群は
      // 1〜3回目の3つなので「1～3合計」に直す(下のP列の集計値も1〜3回目のみの合計)
      ws集計表.getCell('P1').value = '1～3合計';
    }

    // ⑤ 名簿シートに書き込む
    // ヘッダー: F=氏名, 以降は1回目あたり3列（旧「番号」列は廃止）
    //   G,H,I=1回目【会社名/サロン名/配置番号】, J,K,L=2回目, M,N,O=3回目,
    //   P,Q,R=4回目, S,T,U=5回目, V,W,X=6回目
    const ws名簿 = wb.getWorksheet('名簿');
    if (ws名簿) {
      const BLOCK_START_COL = [7, 10, 13, 16, 19, 22]; // G, J, M, P, S, V
      sortedRows.forEach((row, i) => {
        const r = i + 2;
        ws名簿.getCell(`A${r}`).value = i + 1;
        ws名簿.getCell(`B${r}`).value = selectedGuidance;
        ws名簿.getCell(`C${r}`).value = row.class;
        ws名簿.getCell(`D${r}`).value = row.grade;
        ws名簿.getCell(`E${r}`).value = row.number;
        ws名簿.getCell(`F${r}`).value = row.name;

        // 各回ブロックに 会社名 / サロン名 / 配置番号 を直接書き込む
        BLOCK_START_COL.forEach((startCol, j) => {
          const salonName = row.reported ? '' : (row.choices[j] || '');
          const info = salonName ? salonInfoMap[salonName] : undefined;
          ws名簿.getCell(r, startCol).value = info ? info.companyName : '';   // 会社名
          ws名簿.getCell(r, startCol + 1).value = salonName || '';           // サロン名
          ws名簿.getCell(r, startCol + 2).value = info ? info.number : '';   // 配置番号
        });

        // 7回目以降(Y列〜)に残るテンプレートの旧数式を除去
        // （新レイアウトでは会社名文字列を参照して #N/A になるため）
        for (let c = 25; c <= 66; c++) {
          ws名簿.getCell(r, c).value = null;
        }
      });

      // 生徒数を超える余り行(未使用行)にも、テンプレート由来の数式
      // (例: G列のセル自身がG列を参照する自己参照になっている壊れた数式)が
      // そのまま残っており、Excelで開くと「循環参照」エラーになって一部の
      // 集計が正しく再計算されない原因になっていた。名簿シートの全行(1601行)
      // 分、使っていない行のG〜BN列を空にしてこの数式を除去する。
      const lastUsedRow = sortedRows.length + 1;
      for (let r = lastUsedRow + 1; r <= ws名簿.rowCount; r++) {
        for (let c = 7; c <= 66; c++) {
          const cell = ws名簿.getCell(r, c);
          if (cell.value != null) cell.value = null;
        }
      }
    }

    // ⑤' 集計表シートの1〜6回目の件数を、WEB画面の「サロン集計」タブ
    //    (computeSalonCounts)と全く同じロジックでJS側で計算し、静的な数値と
    //    して書き込む。
    //    以前はCOUNTIF数式を名簿シートの配置番号列に向けて書き込み、Excelを
    //    開いたアプリ側の再計算に委ねていたが、fullCalcOnLoadを立てても
    //    アプリによって一部の列しか再計算されず、WEB画面の集計と数字が
    //    食い違う不具合があったため、数式には依存しない方式に変更した。
    if (ws集計表) {
      const roundCounts: Record<string, number[]> = {};
      sortedRows.forEach(row => {
        if (row.reported) return;
        row.choices.forEach((name, i) => {
          if (!name) return;
          if (!roundCounts[name]) roundCounts[name] = [0, 0, 0, 0, 0, 0];
          roundCounts[name][i]++;
        });
      });

      const roundCols = ['E', 'F', 'G', 'H', 'I', 'J']; // 1〜6回目
      const unusedCols = ['K', 'L', 'M', 'N', 'O']; // 7〜11回目(現行仕様では収集しないため常に0)

      salonList.forEach((s, i) => {
        const r = i + 2;
        const counts = roundCounts[s.salonName] ?? [0, 0, 0, 0, 0, 0];

        roundCols.forEach((col, j) => {
          ws集計表.getCell(`${col}${r}`).value = counts[j];
        });
        unusedCols.forEach(col => {
          ws集計表.getCell(`${col}${r}`).value = 0;
        });

        const total6 = counts.reduce((a, b) => a + b, 0);
        ws集計表.getCell(`P${r}`).value = counts[0] + counts[1] + counts[2]; // 1〜3合計
        ws集計表.getCell(`Q${r}`).value = total6; // 1〜6合計
        ws集計表.getCell(`R${r}`).value = total6; // 1〜11合計(7〜11回目は常に0のため1〜6と同じ)
      });

      // テンプレートに残る、現在の求人数を超える予備行(古い配置番号だけが
      // 入っている行)は空欄にしてゴミ数値が残らないようにする
      const lastRow = salonList.length + 1;
      for (let r = lastRow + 1; r <= 147; r++) {
        [...roundCols, ...unusedCols, 'P', 'Q', 'R'].forEach(col => {
          const cell = ws集計表.getCell(`${col}${r}`);
          if (cell.value != null) cell.value = null;
        });
      }

      // 合計行(148): 列ごとの縦計もJS側で計算して静的な数値にする
      const totalRow = 148;
      [...roundCols, ...unusedCols].forEach(col => {
        let sum = 0;
        for (let r = 2; r <= lastRow; r++) {
          const v = ws集計表.getCell(`${col}${r}`).value;
          sum += typeof v === 'number' ? v : 0;
        }
        ws集計表.getCell(`${col}${totalRow}`).value = sum;
      });
    }

    // ⑦ 書き出し後にcalcChain.xmlを除去（ExcelJSが壊れたcalcChainを再生成するため）
    const rawBuffer = await wb.xlsx.writeBuffer();
    const outZip = await JSZip.loadAsync(rawBuffer);
    outZip.remove('xl/calcChain.xml');
    const cleanBuffer = await outZip.generateAsync({ type: 'arraybuffer' });
    const blob = new Blob([cleanBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `ガイダンス_${selectedGuidance}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/sanpou/login');
  };

  if (!authorized) return null;

  return (
    <div className={Styles.page}>
      <NoIndex title="ガイダンス管理 | memorii" />

      {/* ページヘッダー */}
      <div className={Styles.page_header}>
        <p className={Styles.page_header_title}>ガイダンス情報</p>
        <button className={Styles.logout_btn} onClick={handleLogout}>ログアウト</button>
      </div>

      {/* 学校タブ（複数のガイダンスがある場合） */}
      {guidances.length > 1 && (
        <div className={Styles.tabs}>
          {guidances.map(g => (
            <button
              key={g}
              className={selectedGuidance === g ? Styles.tab_active : Styles.tab}
              onClick={() => setSelectedGuidance(g)}
            >
              {g}
            </button>
          ))}
        </div>
      )}

      {/* コントロールバー：ビュー切り替え + フィルター + ダウンロード */}
      <div className={Styles.control_bar}>

        {/* ビュー切り替えトグル */}
        <div className={Styles.toggle_wrap}>
          <button
            className={view === 'students' ? Styles.toggle_active : Styles.toggle}
            onClick={() => setView('students')}
          >
            学生一覧
          </button>
          <button
            className={view === 'salons' ? Styles.toggle_active : Styles.toggle}
            onClick={() => setView('salons')}
          >
            サロン集計
          </button>
        </div>

        {/* フィルター */}
        <div className={Styles.filter_wrap}>
          {uniqueDepts.length > 0 && (
            <div className={Styles.filter_item}>
              <p className={Styles.filter_label}>コース</p>
              <div className={Styles.filter_select_wrap}>
                <select
                  value={filterDept}
                  onChange={e => { setFilterDept(e.target.value); setFilterGrade(''); setFilterClass(''); }}
                >
                  <option value="">未選択</option>
                  {uniqueDepts.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>
            </div>
          )}

          <div className={Styles.filter_item} style={!filterDept && uniqueDepts.length > 0 ? { opacity: 0.4, pointerEvents: 'none' } : {}}>
            <p className={Styles.filter_label}>学年</p>
            <div className={Styles.filter_select_wrap}>
              <select
                value={filterGrade}
                onChange={e => { setFilterGrade(e.target.value); setFilterClass(''); }}
              >
                <option value="">未選択</option>
                {uniqueGrades.map(g => <option key={g} value={g}>{g}</option>)}
              </select>
            </div>
          </div>

          <div className={Styles.filter_item} style={!filterGrade ? { opacity: 0.4, pointerEvents: 'none' } : {}}>
            <p className={Styles.filter_label}>クラス</p>
            <div className={Styles.filter_select_wrap}>
              <select
                value={filterClass}
                onChange={e => setFilterClass(e.target.value)}
              >
                <option value="">未選択</option>
                {uniqueClasses.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* ダウンロードボタン */}
        <button
          className={Styles.download_btn}
          onClick={downloadAll}
          disabled={loading || filteredRows.length === 0}
        >
          Excelダウンロード
        </button>

      </div>

      {loading && <p className={Styles.message}>読み込み中...</p>}

      {/* 学生一覧 */}
      {!loading && view === 'students' && (
        <div className={Styles.scroll_wrap}>
          <div className={Styles.table}>

            <div className={Styles.table_head}>
              <p className={Styles.col_no}>No</p>
              <p className={Styles.col_grade}>年</p>
              <p className={`${Styles.col_class} ${Styles.sortable}`} onClick={() => toggleSort('class')}>
                組 {sortConfig.key === 'class' ? (sortConfig.dir === 'asc' ? '▲' : '▼') : '▲▼'}
              </p>
              <p className={Styles.col_number}>番号</p>
              <p className={Styles.col_name}>氏名</p>
              <p className={`${Styles.col_status} ${Styles.sortable}`} onClick={() => toggleSort('status')}>
                ステータス {sortConfig.key === 'status' ? (sortConfig.dir === 'asc' ? '▲' : '▼') : '▲▼'}
              </p>
              {CHOICE_LABELS.map((label, j) => (
                <p key={j} className={Styles.col_choice}>{label}</p>
              ))}
            </div>

            {sortedRows.length === 0 && (
              <p className={Styles.message}>対象の学生がいません。</p>
            )}

            {sortedRows.map((row, i) => {
              const sp = statusPriority(row);
              return (
                <div key={row.uid} className={Styles.table_row}>
                  <p className={Styles.col_no}>{i + 1}</p>
                  <p className={Styles.col_grade}>{row.grade}</p>
                  <p className={Styles.col_class}>{row.class}</p>
                  <p className={Styles.col_number}>{row.number}</p>
                  <p className={Styles.col_name}>{row.name}</p>
                  <p className={`${Styles.col_status} ${
                    sp === 0 ? Styles.status_answered :
                    sp === 1 ? Styles.status_unanswered :
                               Styles.status_reported
                  }`}>
                    {STATUS_LABEL[sp]}
                  </p>
                  {row.reported
                    ? [0, 1, 2, 3, 4, 5].map(j => (
                        <p key={j} className={`${Styles.col_choice} ${Styles.choice_empty}`}>─</p>
                      ))
                    : [0, 1, 2, 3, 4, 5].map(j => (
                        <p
                          key={j}
                          className={`${Styles.col_choice} ${
                            row.choices[j] ? (j < 3 ? Styles.choice_group1 : Styles.choice_group2) : Styles.choice_empty
                          }`}
                        >
                          {row.choices[j] || '─'}
                        </p>
                      ))
                  }
                </div>
              );
            })}

          </div>
        </div>
      )}

      {/* サロン集計 */}
      {!loading && view === 'salons' && (
        <div className={Styles.scroll_wrap}>
          <div className={Styles.table}>

            <div className={Styles.table_head}>
              <p className={Styles.salon_col_name}>サロン名</p>
              {CHOICE_LABELS.map(label => (
                <p key={label} className={Styles.salon_col_count}>{label}</p>
              ))}
              <p className={Styles.salon_col_total}>合計（第1〜6志望）</p>
              <p className={Styles.salon_col_total}>合計（第1〜5志望）</p>
            </div>

            {salonCounts.length === 0 && (
              <p className={Styles.message}>データがありません。</p>
            )}

            {salonCounts.map(s => (
              <div key={s.name} className={Styles.table_row}>
                <p className={Styles.salon_col_name}>{s.name}</p>
                {s.counts.map((c, i) => (
                  <p
                    key={i}
                    className={`${Styles.salon_col_count} ${
                      c > 0 ? (i < 3 ? Styles.count_group1 : Styles.count_group2) : ''
                    }`}
                  >
                    {c > 0 ? c : '─'}
                  </p>
                ))}
                <p className={`${Styles.salon_col_total} ${s.total > 0 ? Styles.total_bold : ''}`}>
                  {s.total}
                </p>
                <p className={`${Styles.salon_col_total} ${s.total5 > 0 ? Styles.total_bold : ''}`}>
                  {s.total5}
                </p>
              </div>
            ))}

          </div>
        </div>
      )}

    </div>
  );
};

export default SanpouPage;
